import React from 'react'
import { Form, Text } from 'components/forms'
import ClientSelector from 'components/forms/ClientSelector'
import Button from 'components/Button'
import { notEmpty } from 'helpers/validators'
import { useMutation } from '@apollo/client'
import createRegionMutation from '../../gql/createRegion'
import get from 'lodash/get'

const NewRegion = ({ history }) => {
	const [createRegion] = useMutation(createRegionMutation)
	const handleCreateRegion = fields => {
		createRegion({
			variables: { fields },
			refetchQueries: ['clientTree'],
			update: (cache, { data }) => {
				const id = get(data, 'cashAssist.createRegion.id')
				history.push({
					pathname: `/optionen/kasse/region/${id}`
				})
			}
		})
	}
	return(
		<Form onSubmit={handleCreateRegion}>
			<ClientSelector lastNode='DEPARTMENT' field='departmentId' {...notEmpty()} />
			<Text label='Name' field='name' {...notEmpty()} />
			<Button type='submit' text='speichern' status='primary' size='small'/>
		</Form>
	)
}

export default NewRegion
